import React  from 'react'
import Modal from '../../../../components/Modal'
import styled from 'styled-components'
import NFTButton from '../NFTButton'
import { useRemoveNFTOnSale } from '../../../../hooks/useNFTMarketPlace'

interface INFTRemoveModal {
  isOpen: boolean
  onDismiss: () => void
  NFTName: string
  tokenId: number
  getSalesNFTItems: () => void
}

const NFTSellModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;

  .category-error {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.secondary1};
    font-weight: bold;
  }
`

const NFTSellModalMeta = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
`

const NFTSellModalButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  .nft-button {
    margin-right: 0.5rem;
    &:last-child {
      margin-right: 0;
    }
  }
`

export default function NFTRemoveModal({ isOpen, onDismiss, NFTName, tokenId, getSalesNFTItems }: INFTRemoveModal) {
  const [removeNFTCallBack] = useRemoveNFTOnSale(tokenId)

  function NFTRemoveTrigger() {
    removeNFTCallBack().then(() => {
      setTimeout(() => getSalesNFTItems(), 2000)
      onDismiss()
    })
  }
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <NFTSellModalWrapper>
        <NFTSellModalMeta>Removing {NFTName} are u sure</NFTSellModalMeta>
        <NFTSellModalButtons>
          <NFTButton text="Remove" onClick={NFTRemoveTrigger} />
          <NFTButton onClick={() => onDismiss()} text="Cancel" />
        </NFTSellModalButtons>
      </NFTSellModalWrapper>
    </Modal>
  )
}
